import api from './axios';

const base = '/admin/master-themes';

const masterThemes = {
  list: (params) => api.get(base, { params }),
  get: (id) => api.get(`${base}/${id}`),
  create: (data, config) => api.post(base, data, config),
  update: (id, data, config) => api.put(`${base}/${id}`, data, config),
  remove: (id) => api.delete(`${base}/${id}`),
};

export default masterThemes;
